export class ProgressInfo {
  public get numTotalIterations(): number {
    return this._numTotalIterations;
  }

  public get progressValue(): number {
    return this._progressValue;
  }

  public get progressValueSegmentCount(): number {
    return 100;
  }

  public get actualIterations(): number {
    return this._numIterations;
  }

  private _numTotalIterations: number;
  private _progressValue: number;
  private _numIterations: number;

  constructor(numTotalIterations: number) {
    this._numTotalIterations = numTotalIterations;
    this._numIterations = 0;
    this.recalcProgressValue();
  }

  public reset(): void {
    this._numIterations = 0;
    this.recalcProgressValue();
  }

  public incrementIteration(): void {
    this._numIterations++;
    this.recalcProgressValue();
  }

  public incrementIterations(numIterations: number): void {
    this._numIterations += numIterations;
    this.recalcProgressValue();
  }

  public complete(): void {
    this._numIterations = this._numTotalIterations;
    this._progressValue = 100;
  }

  private recalcProgressValue(): void {
    if (this._numTotalIterations <= 0) {
      this._progressValue = 0;
    }
    this._progressValue = this._numIterations > 0 ? Math.round((this._numIterations / this._numTotalIterations) * 100) : 0;
  }
}
